import { motion, useScroll } from "framer-motion";
import { useTransform } from "framer-motion";
import { useEffect, useState } from "react";
import { useWindowSize } from "../../hooks";

export const ScrollingNose = () => {
  const { width } = useWindowSize();
  const [dimensions, setDimensions] = useState<DimensionConstants>(large);
  const { scrollYProgress } = useScroll();
  const radius = useTransform(scrollYProgress, [0.2, 0.35, 0.55], ["0%", "80%", "0%"]);

  useEffect(() => {
    if (!width) return;

    if (width < breakPoints.sm) {
      setDimensions(small);
    } else if (width < breakPoints.md) {
      setDimensions(medium);
    } else {
      setDimensions(large);
    }
  }, [width]);

  return (
    <div className="mix-blend-multiply max-sm:hidden dark:mix-blend-exclusion dark:hue-rotate-180 dark:invert">
      <motion.svg width={dimensions.width} height={dimensions.height}>
        <motion.mask id="svgmask4">
          <motion.circle fill="#ffffff" cx="50%" cy="50%" r={radius}></motion.circle>
        </motion.mask>

        <motion.image
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref="/static/nose.png"
          mask="url(#svgmask4)"
          width={dimensions.width}
          height={dimensions.height}
        ></motion.image>
      </motion.svg>
    </div>
  );
};

type DimensionConstants = {
  width: number;
  height: number;
};

const small: DimensionConstants = {
  width: 300,
  height: 200,
} as const;

const medium: DimensionConstants = {
  width: 600,
  height: 400,
} as const;

const large: DimensionConstants = {
  width: 600,
  height: 400,
} as const;

const breakPoints = {
  sm: 480,
  md: 768,
} as const;
